<script>

import Modal from './Modal.vue';
import Tooltip from './Tooltip.vue';

export default {
    name: "Atomium",

    props: {
        spheres: Object,
    },


    components: {
        Modal,
        Tooltip
    },

    data() {
        return {
            showModal: false,
            modalText: '',
            tooltip: {
                visible: false,
                content: '',
                x: 0,
                y: 0
            }
        }
    },
    methods: {
        openModal(text) {
            this.modalText = text;
            this.showModal = true;
        },
        showTooltip(evt, content) {
            // Get bounding rect for parent div to position tooltip relative to it
            const parentRect = this.$el.getBoundingClientRect();
            const circleRect = evt.target.getBoundingClientRect();
            // Position tooltip near the circle, relative to parent
            const centerX = circleRect.left - parentRect.left + circleRect.width / 2;
            const y = circleRect.top - parentRect.top - 10; // 10px above
            this.tooltip.content = content;
            this.tooltip.visible = true;
            this.$nextTick(() => {
                const tooltipEl = this.$el.querySelector('.tooltip');
                if (tooltipEl) {
                    const tooltipWidth = tooltipEl.offsetWidth;
                    this.tooltip.x = centerX - tooltipWidth / 2;
                    this.tooltip.y = y;
                } else {
                    this.tooltip.x = centerX;
                    this.tooltip.y = y;
                }
            });
        },
        hideTooltip() {
            this.tooltip.visible = false;
        }
    }
}
</script>

<template>
    <div class="vue-atomium" style="position: relative;">
        <svg id="Laag_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 600 300" style="display: block;">
            <defs>
                <linearGradient id="Nieuwe_verloopstaal_1" data-name="Nieuwe verloopstaal 1" x1="370.8" y1="81.6" x2="411.2" y2="81.6" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stop-color="#5cb4e6"/>
                    <stop offset="1" stop-color="#2c4295"/>
                </linearGradient>
                <linearGradient id="Nieuwe_verloopstaal_11" data-name="Nieuwe verloopstaal 1" x1="204.7" y1="177.6" x2="237.3" y2="177.6" xlink:href="#Nieuwe_verloopstaal_1"/>
            </defs>
            <circle v-if="spheres[0]" class="st6" cx="300" cy="42.8" r="16.5"
                @click="openModal(spheres[0].text)"
                @mouseenter="showTooltip($event, spheres[0].title)"
                @mouseleave="hideTooltip"
            />
            <circle v-if="spheres[1]" class="st3" cx="300" cy="135.3" r="23.7"
                @click="openModal(spheres[1].text)"
                @mouseenter="showTooltip($event, spheres[1].title)"
                @mouseleave="hideTooltip"
            />
            <circle v-if="spheres[2]" class="st5" cx="208.9" cy="81.8" r="20.3"
                @click="openModal(spheres[2].text)"
                @mouseenter="showTooltip($event, spheres[2].title)"
                @mouseleave="hideTooltip"
            />
            <circle v-if="spheres[3]" class="st4" cx="391" cy="81.6" r="20.2"
                @click="openModal(spheres[3].text)"
                @mouseenter="showTooltip($event, spheres[3].title)"
                @mouseleave="hideTooltip"
            />
            <circle v-if="spheres[4]" class="st2" cx="379" cy="177.6" r="16.3"
                @click="openModal(spheres[4].text)"
                @mouseenter="showTooltip($event, spheres[4].title)"
                @mouseleave="hideTooltip"
            />
            <circle v-if="spheres[5]" class="st1" cx="221" cy="177.6" r="16.3"
                @click="openModal(spheres[5].text)"
                @mouseenter="showTooltip($event, spheres[5].title)"
                @mouseleave="hideTooltip"
            />
            <g>
               <path class="st0" d="M315.3,216.5l-6.8-59.2,1.7-.8c.2,0,.3-.2.5-.2,4.1-2.1,7.5-5.3,9.8-9.3l1.3-2.2,41.4,28.7-.2,1.5c-.3,1.6-.3,3.3,0,4.9l.2,1.4-47.7,35.2ZM313.6,160.1l5.5,47.8,39-28.8c0-1.2,0-2.3,0-3.5l-34.9-24.2c-2.5,3.6-5.8,6.5-9.6,8.6Z"/>
                <path class="st0" d="M285.3,216.9l-48.4-35.7.2-1.4c.2-1.7.2-3.3,0-4.9l-.2-1.5,41.4-28.7,1.3,2.2c2.5,4.4,6.3,7.8,11,9.9l1.6.7-6.8,59.4ZM241.9,179.1l39.6,29.3,5.5-47.9c-4.1-2.1-7.6-5.2-10.3-8.9l-34.9,24.2c.1,1.1.1,2.3,0,3.5Z"/>
                <path class="st0" d="M281.6,120.1l-54-31.2.5-1.8c.8-2.8,1-5.6.6-8.4l-.3-1.8,58-25.2,1.1,1.4c1.9,2.3,4.5,4.1,7.4,5.1l1.6.5v52.9l-1.8.4c-1.9.4-3.8,1.1-5.5,2-2.4,1.2-4.5,2.8-6.3,4.7l-1.3,1.3ZM233,86.7l47.8,27.6c1.9-1.7,4-3.2,6.3-4.4,1.5-.8,3.1-1.4,4.8-1.9v-46c-2.5-1.1-4.8-2.6-6.7-4.6l-51.7,22.4c.2,2.3,0,4.5-.5,6.8Z"/>
                <path class="st0" d="M318.4,120.1l-1.3-1.3c-3.2-3.3-7.3-5.7-11.8-6.7l-1.8-.4v-52.9l1.6-.5c2.9-.9,5.5-2.7,7.5-5.1l1.1-1.3,57.9,25.1-.3,1.8c-.4,2.8-.2,5.7.6,8.4l.5,1.8-54,31.2ZM308.2,108c4.1,1.2,7.9,3.4,11,6.3l47.8-27.6c-.5-2.2-.6-4.5-.5-6.8l-51.5-22.4c-2,2-4.3,3.5-6.8,4.6v45.9Z"/>
                <path class="st0" d="M366.3,167.2l-42.7-29.6v-1.3c.2-2.9-.2-5.7-1.1-8.4l-.6-1.8,54.1-31.2,1.3,1.2c1.3,1.3,2.8,2.3,4.5,3.2l1.4.7-7,61.5-1.5.4c-2.6.7-5,2.1-6.9,3.9l-1.4,1.3ZM328.4,135.2l37.5,26c1.8-1.4,3.8-2.5,5.9-3.3l6.3-55.3c-1-.6-1.9-1.3-2.8-2l-47.9,27.6c.6,2.3.9,4.6.8,6.9Z"/>
                <path class="st0" d="M233.7,167.2l-1.4-1.3c-1.9-1.9-4.3-3.2-6.9-3.9l-1.5-.4-7-61.5,1.4-.7c1.6-.9,3.1-2,4.5-3.2l1.3-1.2,54.1,31.2-.6,1.8c-.9,2.7-1.3,5.6-1.1,8.4v1.3c0,0-42.7,29.6-42.7,29.6ZM228.2,157.9c2.1.8,4.1,1.9,5.9,3.3l37.5-26c0-2.4.3-4.7.9-6.9l-47.9-27.6c-.9.7-1.8,1.4-2.8,2l6.3,55.3Z"/>
                <path class="st0" d="M421.8,277.6h-29.4l-18.4-79.6c-1.6-.4-3.2-1-4.7-1.7-1.3-.7-2.6-1.5-3.8-2.5l-44.5,32.8,5.7,50.2h-53.2l5.7-49.8-45.1-33.3c-1.2,1-2.4,1.8-3.8,2.5-1.5.8-3.1,1.3-4.7,1.7l-18.4,79.6h-29.4l30-83.5c-2.4-1.9-4.3-4.2-5.7-6.9-2.5-5-3-10.6-1.3-16,1.7-5.3,5.4-9.6,10.4-12.2.1,0,.2-.1.3-.2l-6-52.7c-8.1-1-15.2-6-19-13.3-6.2-12.1-1.4-27,10.8-33.2,9.9-5.1,22-2.8,29.4,5.3l52.1-22.6c.3-11.3,9.6-20.4,20.9-20.4s20.7,9.2,20.9,20.5l51.9,22.5c7.4-8.1,19.5-10.4,29.4-5.3,12.1,6.2,17,21.1,10.8,33.2-3.7,7.3-10.9,12.3-19,13.3l-6,52.7c.1,0,.2.1.3.2,5,2.5,8.7,6.9,10.4,12.2,1.7,5.3,1.3,11-1.3,16-1.4,2.7-3.3,5.1-5.7,6.9l30,83.5ZM396.2,272.9h19l-28.9-80.6,1.6-1c2.4-1.5,4.3-3.7,5.6-6.2,2-3.9,2.3-8.3,1-12.4-1.3-4.1-4.2-7.5-8.1-9.5-.5-.3-1-.5-1.6-.7l-1.7-.6,6.9-60.1h2c7.2-.4,13.7-4.6,17-11,2.4-4.8,2.9-10.2,1.2-15.3-1.6-5.1-5.2-9.2-9.9-11.7-8.5-4.3-18.9-2.1-24.8,5.4l-1.1,1.4-58.1-25.2v-1.6c.1-.3.1-.6.1-1,0-9-7.3-16.2-16.2-16.2s-16.2,7.3-16.2,16.2,0,.6,0,.9v1.6c0,0-58.2,25.3-58.2,25.3l-1.1-1.4c-5.9-7.5-16.3-9.7-24.8-5.4-9.8,5-13.7,17.1-8.7,26.9,3.3,6.4,9.8,10.6,17,10.9h2c0,0,6.9,60.2,6.9,60.2l-1.7.6c-.5.2-1.1.4-1.6.7-3.9,2-6.7,5.3-8.1,9.5-1.3,4.1-1,8.5,1,12.4,1.3,2.5,3.2,4.7,5.6,6.2l1.6,1-28.9,80.6h19l18.2-79,1.6-.2c1.7-.3,3.3-.8,4.9-1.6,1.5-.8,2.9-1.8,4.1-3l1.4-1.4,50.4,37.2-5.4,47.2h42.7l-5.4-47.7,49.8-36.8,1.4,1.4c1.2,1.2,2.6,2.2,4.1,3,1.5.8,3.2,1.3,4.9,1.6l1.6.2,18.2,79Z"/>
            </g>
        </svg>
        <Modal :visible="showModal" :text="modalText" @close="showModal = false" />
        <Tooltip
            :content="tooltip.content"
            :x="tooltip.x"
            :y="tooltip.y"
            :visible="tooltip.visible"
        />
    </div>
</template>

<style scoped>
.st0 {
    fill: white;
}

.st1 {
    fill: url(#Nieuwe_verloopstaal_11);
}

.st2 {
    fill: white;
}

.st3 {
    fill: #afdff9;
}

.st4 {
    fill: url(#Nieuwe_verloopstaal_1);
}

.st5 {
    fill: #5cb4e6;
}

.st6 {
    fill: #2c4295;
}
</style>